import { FC } from 'react';

import useGetDocumentFormPdfUrl from '@/api/queries/files/useGetDocumentFormPdfUrl';

type FinalisedPdfFormViewerProps = {
  documentId: string;
};

const FinalisedPdfFormViewer: FC<FinalisedPdfFormViewerProps> = (props) => {
  const { documentId } = props;
  const { finalisedPdfUrl, isLoading } = useGetDocumentFormPdfUrl(documentId);

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <p className="text-gray-500">Loading PDF...</p>
      </div>
    );
  }

  if (!finalisedPdfUrl) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <p className="text-gray-500">
          PDF not available. The finalised PDF for this form could not be found.
        </p>
      </div>
    );
  }

  return (
    <iframe
      src={finalisedPdfUrl}
      title="Finalised PDF form"
      // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Viewport-relative size
      className="h-full min-h-[80vh] w-full border-0"
      referrerPolicy="no-referrer"
    />
  );
};

export default FinalisedPdfFormViewer;
